import React, { Component } from "react";
import { connect } from "react-redux";
import { Pie } from "react-chartjs-2";
import moment from "moment";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import Menu from "../menu";
import { DatePicker, Button } from "../../components";
import { Globals, axios } from "../../utils";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

// const COLORS = ["#309bf9", "#50d177", "#0fe2db", "#cc566e", "#febd25"];
const COLORS = [
    '#E7000B',
    '#FF8904',
    '#E17100',
    '#FDC700',
    '#5EA500',
    '#05DF72',
    '#009966',
    '#00D5BE',
    '#0092B8',
    '#00BCFF',
    '#155DFC',
    '#7C86FF',
    '#7F22FE',
    '#C27AFF',
    '#C800DE',
    '#FB64B6',
    '#EC003F',
    '#90A1B9',
    '#4A5565',
    '#9F9FA9',
    '#525252',
    '#A6A09B',
]

class IncomeProfitReport extends Component {
    constructor(props) {
        super(props);

        // Fechas por defecto: mismo día del mes anterior y fecha actual
        const defaultSince = moment().subtract(1, 'month').format('DD-MM-YYYY');
        const defaultUntil = moment().format('DD-MM-YYYY');

        this.state = {
            pieChartData: [],
            totalSales: 0,
            totalProfit: 0,
            form: {
                since: defaultSince,
                until: defaultUntil,
                user_id: this.props.user.role === 4
                    ? (this.props.user.enterprise_users || {}).enterprise_id || this.props.user.id
                    : this.props.user.id,
            },
            dates: {
                minDate: "",
                maxDate: ""
            },
        };
    }

    componentDidMount() {
        this.fetchReport();
    }

    fetchReport = async () => {
        try {
            const { form } = this.state;

            const params = {
                user_id: form.user_id,
                since: moment(form.since, "DD-MM-YYYY").format("YYYY-MM-DD"),
                until: moment(form.until, "DD-MM-YYYY").format("YYYY-MM-DD"),
            };

            const response = await axios.post('admin/reports/income-profit', params);

            const { total_sales, total_profit, payment_methods } = response.data;

            const pieChartData = (payment_methods || []).map((method, index) => ({
                name: method.name,
                value: method.value,
                color: COLORS[index % COLORS.length],
            }));

            this.setState({
                totalSales: total_sales,
                totalProfit: total_profit,
                pieChartData,
            });

        } catch (error) {
            console.error("Error fetching income-profit report", error);
        }
    };

    handleDateChange = (field, value) => {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [field]: moment(value).format("DD-MM-YYYY")
            }
        }), this.fetchReport);
    };

    returnState = () => {
        // Restablecer a fechas por defecto
        const defaultSince = moment().subtract(1, 'month').format('DD-MM-YYYY');
        const defaultUntil = moment().format('DD-MM-YYYY');

        this.setState({
            form: {
                ...this.state.form,
                since: defaultSince,
                until: defaultUntil
            }
        }, this.fetchReport);
    };

    render() {
        const { totalSales, totalProfit, pieChartData, form } = this.state;

        return (
            <Menu history={this.props.history}>
                <div id="income-profit-report">
                    {/* Filtros de Fecha */}
                    <div id="products" className="new-reports">
                        <div className="row">
                            <div className="col-md-2">
                                <DatePicker
                                    color="white"
                                    label="Desde"
                                    className="filter"
                                    value={moment(form.since, "DD-MM-YYYY").toDate()}
                                    onChange={value => this.handleDateChange("since", value)}
                                />
                            </div>
                            <div className="col-md-2">
                                <DatePicker
                                    color="white"
                                    label="Hasta"
                                    className="filter"
                                    value={moment(form.until, "DD-MM-YYYY").toDate()}
                                    onChange={value => this.handleDateChange("until", value)}
                                />
                            </div>
                            <div className="col-md-4">
                                <div className="container-buttons">
                                    <Button className="btn-align-bottom btn-filter" color=" " onClick={this.returnState}>
                                        <span>Limpiar</span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Gráficas */}
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "40px",
                        padding: "20px 0"
                    }}>
                        <div style={{ width: "100%", maxWidth: "500px", textAlign: "center" }}>
                            <h4>Total ingresos y ganancias por ventas($)</h4>
                            <Pie
                                data={{
                                    labels: ["Ventas", "Ganancias"],
                                    datasets: [{
                                        data: [totalSales, totalProfit],
                                        backgroundColor: ["#50d177", "#309bf9"],
                                        borderWidth: 1
                                    }]
                                }}
                                options={{
                                    plugins: {
                                        legend: {
                                            display: true,
                                            position: "right",
                                            labels: {
                                                usePointStyle: true,
                                                boxHeight: 15,
                                                boxWidth: 15,
                                                font: {
                                                    size: 14,
                                                },
                                            },
                                        },
                                        datalabels: {
                                            display: true,
                                            color: "white",
                                            font: { weight: "bold", size: 14 },
                                            formatter: (value) => `$${Globals.formatMiles(value)}`
                                        }
                                    }
                                }}
                            />
                        </div>

                        <div style={{ width: "100%", maxWidth: "500px", textAlign: "center" }}>
                            <h4>Monto de ventas según método de pago($)</h4>
                            <Pie
                                data={{
                                    labels: pieChartData.map(pm => pm.name),
                                    datasets: [{
                                        data: pieChartData.map(pm => pm.value),
                                        backgroundColor: pieChartData.map(pm => pm.color),
                                        borderWidth: 1
                                    }]
                                }}
                                options={{
                                    plugins: {
                                        legend: {
                                            display: true,
                                            position: "right",
                                            labels: {
                                                usePointStyle: true,
                                                boxHeight: 15,
                                                boxWidth: 15,
                                                font: {
                                                    size: 14,
                                                },
                                                generateLabels: (chart) => {
                                                    try {
                                                        const dataset = chart.data.datasets && chart.data.datasets[0];
                                                        if (!dataset) return [];

                                                        const data = dataset.data || [];
                                                        const total = data.reduce((a, b) => Number(a) + Number(b), 0);

                                                        return (chart.data.labels || []).map((l, i) => {
                                                            const percentage = total > 0 ? (Number(data[i]) / total) * 100 : 0;

                                                            let isHidden = false;
                                                            try {
                                                                if (typeof chart.getDataVisibility === 'function') {
                                                                    isHidden = !chart.getDataVisibility(i);
                                                                } else {
                                                                    const meta = chart.getDatasetMeta(0);
                                                                    if (meta && meta.data && meta.data[i]) {
                                                                        isHidden = meta.data[i].hidden;
                                                                    }
                                                                }
                                                            } catch (e) { /* ignore */ }

                                                            return {
                                                                datasetIndex: i,
                                                                index: i,
                                                                text: `${percentage.toFixed(2)}% ${l}`,
                                                                fillStyle: dataset.backgroundColor ? dataset.backgroundColor[i] : '#000',
                                                                strokeStyle: dataset.backgroundColor ? dataset.backgroundColor[i] : '#000',
                                                                hidden: isHidden,
                                                            };
                                                        });
                                                    } catch (error) {
                                                        console.error("Error in generateLabels:", error);
                                                        return [];
                                                    }
                                                },
                                            },
                                        },
                                        datalabels: {
                                            display: false,
                                            color: "white",
                                            font: { weight: "bold", size: 14 },
                                            formatter: (value) => `$${value.toFixed(2)}`
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Menu>
        );
    }
}

export default connect(state => ({
    user: state.user
}))(IncomeProfitReport);